class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');

    // Open/close on hover too (desktop only — devices without a real
    // hover pointer, like phones/tablets, keep the normal tap behavior).
    if (window.matchMedia('(hover: hover)').matches) {
      this.addEventListener('mouseenter', this.onMouseEnter.bind(this));
      this.addEventListener('mouseleave', this.onMouseLeave.bind(this));
    }
  }

  onMouseEnter() {
    clearTimeout(this.hoverCloseTimeout);
    if (!this.mainDetailsToggle.hasAttribute('open')) {
      this.mainDetailsToggle.setAttribute('open', '');
    }
  }

  onMouseLeave() {
    // Small delay so moving the cursor from the trigger into the
    // dropdown content doesn't momentarily close it.
    this.hoverCloseTimeout = setTimeout(() => {
      this.close();
    }, 150);
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    // Force the solid/scrolled header look while a menu is open (e.g.
    // on a transparent homepage header) so the dropdown doesn't float
    // over the see-through hero image — same class the scroll handler
    // uses, so it falls back correctly once actually scrolled.
    if (this.mainDetailsToggle.open) {
      this.header.classList.add('is-scrolled');
    } else if (window.scrollY <= 10 && !this.header.querySelector('header-menu details[open]')) {
      // Don't drop the solid look if another menu item is still open —
      // e.g. hovering straight from "Earrings" onto "Rings" closes
      // Earrings' <details> right as Rings' opens; without this check
      // that close event would flip the header back to transparent
      // for a frame even though Rings' dropdown is still showing.
      this.header.classList.remove('is-scrolled');
    }

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
